import React from 'react';
import { Path } from 'react-native-svg';
import withDefaultIconProps from './withDefaultIconProps';
import SVGIcon from './SVGIcon';
const Icon = ({ color, ...rest }) => {
    return (React.createElement(SVGIcon, { ...rest },
        React.createElement(Path, { stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M16.6 6 6.3 17l-3.5-3.5M21.8 6 11.5 17l-1.1-1", fill: "none" })));
};
export default withDefaultIconProps(Icon);
